import React, {useState, useContext} from "react";

import AuthContainer from "../../Authentication/AuthContainer";
import WelcomeContainer from "../../Authorization/WelcomeContainer";
import UserContext from "../../../context/UserContext";
import ErrorDescription from "../../common/Errors";

const Content = () => {
    const { unknown_device, setUnknownDevice, error } = useContext(UserContext)
    const [ authState, setAuthState ] = useState(!unknown_device)
    
    const toogleAuthState = (status) => {
        setUnknownDevice(!status)
    }

    if (!!error) {
        return (<div
                id="content"
                className={`element-border`}
            >
            <ErrorDescription error={error}/>
    </div>)
    }

    return <div
        id="content"
        className={`element-border`}
    >
        {
            !unknown_device
            // authState
        
                ? <WelcomeContainer/>
                :  <AuthContainer
                    setAuthorizedDevice={toogleAuthState}
                    />
        }

    </div>
}

export default Content